import { hasLocale, type Locale } from "next-intl";
import { defineRouting } from "next-intl/routing";

export const routing = defineRouting({
  locales: [ "en" ],
  defaultLocale: "en",
  // English keeps its existing unprefixed URLs; other locales are served under `/<locale>`.
  localePrefix: "as-needed",
  localeDetection: false,
  // Avoid setting a cookie on responses that CloudFront may cache.
  localeCookie: false,
  // Keep hreflang alternates out of response headers until non-English locales launch.
  alternateLinks: false,
});

/** Shared by server and client so formatted dates match during hydration. */
export const TIME_ZONE = "Europe/London";

export const isLocale = (value: unknown): value is Locale => (
  typeof value === "string" && (routing.locales as readonly string[]).includes(value)
);

/**
 * The default locale is unprefixed and is the only locale pre-built at build time;
 * other locales render on first request and are then cached.
 */
export const isDefaultLocale = (locale: string): boolean => locale === routing.defaultLocale;

/**
 * Narrows a `[locale]` route param, which Next types as `string`.
 * The root layout 404s unknown locales, so the fallback is never reached at runtime.
 */
export const toLocale = (value: string): Locale => (
  hasLocale(routing.locales, value) ? value : routing.defaultLocale
);

export interface ILocaleStaticParamsArgs {
  params: { locale: string };
}
